import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { putWarehouseStageUsers } from '../../../services/WarehouseStage/WarehouseStageUsers';

const WarehouseProcessUserStatusChange = ({  status,
  editData,
  sendDataToWarehouseConfig,
  warehouseId, }) => {
  const [statusValue, setStatusValue] = useState(status === true);

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    let updatedData = {
      status: newStatus ? 'true' : 'false',
      id: editData.id,
      stageId: editData.wareHouseGarmentProcessStage.id,
      wareHouseUserId: editData.wareHouseUser.id,
    };
     
    putWarehouseStageUsers(warehouseId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            sendDataToWarehouseConfig({
              success: true,
            });
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  return (
    <div style={{ margin: '10px 0 10px 5px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: '15px',
          width: '100%',
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default WarehouseProcessUserStatusChange;
